export default function Chapter({ index, label }) {
  return (
    <div data-testid={`chapter-${index}`} className="flex items-center gap-4">
      <span className="font-mono-tech text-xs font-bold text-[#A1A1AA]">
        {String(index).padStart(2, "0")}
      </span>
      <span className="h-px w-12 bg-[#E63946]" aria-hidden="true" />
      <span className="font-mono-tech text-sm uppercase tracking-[0.2em] text-[#E63946] font-semibold">
        {label}
      </span>
    </div>
  );
}
